import React from 'react'

export const NoMatch = () => (
    <div>
        <h1>404 error: Page Not Found Error</h1>
    </div>
)